import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import MenuItemIcon from './MenuItemIcon';
import MenuItemText from './MenuItemText';

const styles = (theme) => ({
  root: {
    borderRight: '4px solid transparent',
    '&:hover': {
      backgroundColor: theme.palette.xpl.dm.background,
      '& svg, & span': {
        color: theme.palette.xpl.foreground,
      },
    },
    '&$selected:hover': {
      backgroundColor: theme.palette.xpl.dm.background,
      '& svg': {
        color: theme.palette.xpl.dm.primary.default,
      },
    },
    '&$selected': {
      backgroundColor: theme.palette.xpl.navigation,
    },
  },
  itemText: {
    paddingLeft: '5px',
    fontSize: '14px',
  },
  selected: {
    borderRight: `4px solid ${theme.palette.xpl.dm.primary.default}`,
  },
});

const LinkedMenuItem = (props) => {
  const {
    path,
    classes,
    selected,
    Icon,
    name,
    className,
    isExternal,
    isSubMenuItem,
  } = props;

  const externalLinkClick = useCallback(
    (e) => {
      e.preventDefault();
      window.open(path);
    },
    [path]
  );

  return (
    <ListItem
      button
      component={isExternal ? null : Link}
      to={isExternal ? null : path}
      selected={selected}
      className={classNames(classes.root, className)}
      classes={{ selected: classes.selected }}
      onClick={isExternal ? externalLinkClick : null}>
      {Icon && <MenuItemIcon selected={selected} Icon={Icon} />}
      <MenuItemText
        name={name}
        selected={selected}
        isSubMenuItem={isSubMenuItem}
      />
    </ListItem>
  );
};

LinkedMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Icon: PropTypes.object,
  selected: PropTypes.bool,
  isExternal: PropTypes.bool,
  isSubMenuItem: PropTypes.bool,
};

LinkedMenuItem.defaultProps = {
  selected: false,
  isExternal: false,
  Icon: null,
  isSubMenuItem: false,
};

export default withStyles(styles)(LinkedMenuItem);
